
import { FaBarsStaggered} from "react-icons/fa6";
// import { AiOutlineClose } from "react-icons/ai";
// import { NavHashLink } from "react-router-hash-link";
import SideTopnav from "./SideTopnav";
import logo5 from "../Assets/logo5.png"
const Topnavbar = ({togglemenu,settogglemenu}) => {
  

  return (
    <>
      <div className={`bg-black z-40 fixed top-0 w-full flex-col hidden lg:flex`}>
        {/*visible*/}
        <div className=" h-16  flex items-center w-full justify-between ">
          {/* Name */}
          <div className="text-abouttext w-52    text-4xl ml-1 font-Cursive">
            <img src={logo5} alt="logo" className="w-full " />
          </div>
          <div className="mr-4 mt-2 ml-2 h-10 cursor-pointer select-none">
            {togglemenu && (
              <FaBarsStaggered
                fill="white"
                size={"23px"}
                fontWeight={"normal"}
                onClick={() => {
                  settogglemenu(false);
                }}
              />
            )}  
          </div>
        </div>

        {/*hidden menu  */}
        <SideTopnav togglemenu={togglemenu} settogglemenu={settogglemenu}/>
     
      </div>
       




    </>
  );
};

export default Topnavbar;
